import React from 'react';
import {
  Banner,
  Tile,
  Alert,
  Anchor,
  Bubble,
  Currency,
  List,
  ListItem,
  Heading,
  NewTable,
  Status,
  VStack,
} from '@carta/ink';

import ExposeDescribe from '../components/ExposeDescribe';

const PositiveExpose = () => {
  return (
    <ExposeDescribe
      id="Positive elements visual check"
      name="Positive elements visual check"
      key="Positive elements visual check"
    >
      <VStack spacing="xlarge">
        <Tile>
          <Heading variant="heading-2">Alert</Heading>
          <Alert id="default-alert" text="Your data has been saved" />
        </Tile>

        <Tile>
          <Heading variant="heading-2">Banner</Heading>
          <Banner
            text={
              <>
                This option grant was amended from ES-12.{' '}
                <Anchor href="javascript:void(0)" preset="forward">
                  See details
                </Anchor>
              </>
            }
            type="success"
          />
        </Tile>

        <Tile>
          <Heading variant="heading-2">Bubble</Heading>
          <Bubble variant="feedback-positive">Completed</Bubble>
        </Tile>

        <Tile>
          <Heading variant="heading-2">Currency</Heading>
          <Currency value={123.45} colorize />
        </Tile>

        <Tile>
          <Heading variant="heading-2">Status</Heading>
          <Status variant="feedback-positive" primaryText="Sync" secondaryText="Completed" />
        </Tile>

        <Tile>
          <Heading variant="heading-2">Mini Status</Heading>
          <Status variant="feedback-positive" isMini label="Completed" />
        </Tile>

        <Tile>
          <Heading variant="heading-2">ListItem</Heading>
          <List>
            <ListItem variant="feedback-positive" title="Sync" text="Completed" />
            <ListItem variant="feedback-positive" title="Sync" text="Completed" size="medium" />
            <ListItem variant="feedback-positive" title="Sync" text="Completed" size="small" />
          </List>
        </Tile>

        <Tile>
          <Heading variant="heading-2">NewTable.Ribbon</Heading>
          <NewTable>
            <NewTable.Head>
              <NewTable.Row>
                <NewTable.HeadCell>Grant</NewTable.HeadCell>
                <NewTable.HeadCell>Issue Date</NewTable.HeadCell>
                <NewTable.HeadCell>Type</NewTable.HeadCell>
                <NewTable.HeadCell>Status</NewTable.HeadCell>
              </NewTable.Row>
            </NewTable.Head>
            <NewTable.Body>
              <NewTable.Row>
                <NewTable.Cell>
                  <NewTable.Ribbon text="Positive message" variant="feedback-positive" />
                  ES-161
                </NewTable.Cell>
                <NewTable.Cell>04/10/2014</NewTable.Cell>
                <NewTable.Cell>ISO</NewTable.Cell>
                <NewTable.Cell>Accepted by optionholder</NewTable.Cell>
              </NewTable.Row>
              <NewTable.Row>
                <NewTable.Cell>ES-162</NewTable.Cell>
                <NewTable.Cell>08/19/2014</NewTable.Cell>
                <NewTable.Cell>ISO</NewTable.Cell>
                <NewTable.Cell>Terminated</NewTable.Cell>
              </NewTable.Row>
              <NewTable.Row>
                <NewTable.Cell>
                  <NewTable.Ribbon text="Positive message" variant="feedback-positive" />
                  ES-456
                </NewTable.Cell>
                <NewTable.Cell>08/19/2014</NewTable.Cell>
                <NewTable.Cell>ISO/NSO</NewTable.Cell>
                <NewTable.Cell>Sent to optionholder</NewTable.Cell>
              </NewTable.Row>
            </NewTable.Body>
          </NewTable>
        </Tile>
      </VStack>
    </ExposeDescribe>
  );
};

export default PositiveExpose;
